module.exports = __webpack_public_path__ + "img/payment-transactions.b8df0665.jpg";